import { useGeneralInputs } from './useGeneralInputs'
import { useHandlers } from './useHandlers'
import { useInputs } from './useInputs'
import { useObjectXInputs } from './useObjectXInputs'
import { useObjectYInputs } from './useObjectYInputs'

export const useTimeLineCreateOrEdit = () => {
  const { data, handlers, state } = useHandlers()

  const inputsProps = { handlers, state, data }
  const inputs = useInputs(inputsProps)
  const generalInputs = useGeneralInputs(inputsProps)
  const objectXInputs = useObjectXInputs(inputsProps)
  const objectYInputs = useObjectYInputs(inputsProps)

  return {
    data,
    state,
    handlers,
    inputs: {
      ...inputs,
      ...generalInputs,
      ...objectXInputs,
      ...objectYInputs,
    },
  }
}
